import React, { useContext } from "react";
import Joyspace from "@/components/Joyspace";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import GlobalLayout from "@/layout/GlobalLayout";

export default function JoySpacePage() {
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  return (
    // <GlobalLayout>
    <Joyspace basename={appRuntimeEnv.webConfig.routeBase} />
    // </GlobalLayout>
  );
}
